import React from 'react';

export const HeroContent = () => {
  return (
    <header className="d-flex flex-column align-items-center w-100">
      <div className="mb-4 w-100 text-center">
        <p
          className="text-uppercase fw-bold mb-0 d-none d-md-block"
          style={{
            color: '#059669',
            fontSize: '14px',
            letterSpacing: '3.92px'
          }}
        >
          A Nação Saúde nasceu com um propósito claro
        </p>
        <p
          className="text-uppercase fw-bold mb-0 d-block d-md-none"
          style={{
            color: '#059669',
            fontSize: '12px',
            letterSpacing: '2px'
          }}
        >
          A Nação Saúde nasceu com um propósito claro
        </p>
      </div>
      <div className="w-100 text-center" style={{ maxWidth: '638px' }}>
        <h1
          className="fw-bold mb-0 d-none d-md-block"
          style={{
            color: '#0c4a6e',
            fontSize: '24px'
          }}
        >
          Liderar um movimento de bem-estar e saúde que torne o cuidado
          acessível, prático e humano.
        </h1>
        <h1
          className="fw-bold mb-0 d-none d-sm-block d-md-none"
          style={{
            color: '#0c4a6e',
            fontSize: '20px'
          }}
        >
          Liderar um movimento de bem-estar e saúde que torne o cuidado
          acessível, prático e humano.
        </h1>
        <h1
          className="fw-bold mb-0 d-block d-sm-none"
          style={{
            color: '#0c4a6e',
            fontSize: '18px',
            lineHeight: '1.25'
          }}
        >
          Liderar um movimento de bem-estar e saúde que torne o cuidado
          acessível, prático e humano.
        </h1>
      </div>
    </header>
  );
};
